import { useIsFetching, useIsMutating } from "@tanstack/react-query"

import LoadingStyles from "./loading.module.css"
import React from "react"
import classNames from "classnames"
import { useAuthState } from "../../context/auth"
import { useDelayedUnmounting } from "../../hooks/use-delayed-unmounting"
import { useIsSSR } from "../../hooks/use-is-ssr"
import { useLoadingState } from "../../context/loading"

type LoadingProps = {
    disableSSR?: boolean
    loading?: boolean
    blur?: boolean
}

const Loading = ({ disableSSR, loading, blur = true }: LoadingProps) => {
    const { isLoginLoading, isInitialLoading } = useAuthState()
    const { loading: manualLoading } = useLoadingState()
    const isMutating = useIsMutating()
    const isFetching = useIsFetching({ stale: true, predicate: ({ meta }) => !meta?.background })
    const isSSR = useIsSSR()

    const shouldRender = useDelayedUnmounting(
        !!(
            isLoginLoading ||
            manualLoading ||
            isFetching ||
            isMutating ||
            (!disableSSR && isSSR) ||
            (!disableSSR && isInitialLoading) ||
            loading
        )
    )

    if (!shouldRender && !(!disableSSR && isSSR)) return null

    return (
        <section className={classNames(LoadingStyles.container, { [LoadingStyles.blur]: blur })}>
            <svg className={LoadingStyles.spinner} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                <circle cx="20" cy="20" r="16" fill="none" />
                <circle cx="20" cy="20" r="16" fill="none" />
            </svg>
        </section>
    )
}

export default Loading
